/**
 * bz-gut-brain-guide.js
 * Gut-Brain Axis Guide — Page JavaScript (US market)
 * Built 2026-04-29: US Gut-Brain Lane LP for PMax campaign C23750480365.
 * Lane-specific config: mixed PRO+ELITE shelf, WELCOME10 discount.
 * FDA structure-function compliant. No disease claims.
 */

/* ─────────────────────────────────────────────────────────────────────
   1. SHARED CONFIG — US market
   ───────────────────────────────────────────────────────────────────── */

window.BZ = window.BZ || {};

BZ.PRODUCTS = {
  us: {
    elite:    { name: 'FOCUS ELITE™',    shortName: 'ELITE',    price: '$65', priceSub: '$54.55/mo', url: '/products/gaba-supplements',      cart: '/cart/48197708710080:1', purpose: 'Stress-free focus, positive mood & brain health' },
    pro:      { name: 'FOCUS PRO™',      shortName: 'PRO',      price: '$40', priceSub: '$33.60/mo', url: '/products/dopamine-supplements', cart: '/cart/48182077849792:1', purpose: 'Strong focus, motivation & memory' },
    original: { name: 'FOCUS ORIGINAL™', shortName: 'ORIGINAL', price: '$25', priceSub: '$21.00/mo', url: '/products/brainzyme-original-milder-formula', cart: '/cart/39256054857920:1', purpose: 'Mild everyday focus & calm mood' }
  }
};

BZ.MARKETS = {
  us: {
    lang: 'en',
    proofStrip: [
      '<strong>2,000+</strong> medical professionals trust Brainzyme®',
      '<strong>365-day</strong> money-back guarantee',
      '<strong>GMP & HACCP</strong> certified, made in Scotland'
    ],
    reviewStats: { rating: '4.74', count: '6,020+', source: 'verified reviews' }
  }
};

/* ─────────────────────────────────────────────────────────────────────
   2. LP_CONFIG — Gut-Brain lane US
   ───────────────────────────────────────────────────────────────────── */

var LP_CONFIG = {
  product: 'elite',
  market: 'us',
  discountCode: 'WELCOME10',
  recommendedSku: 'elite'
};

/* ─────────────────────────────────────────────────────────────────────
   3. PRODUCT SHELF — mixed PRO+ELITE (ELITE recommended, PRO secondary)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  var market = 'us';
  var p = BZ.PRODUCTS[market];

  var PRODUCTS = [
    {
      key: 'original',
      name: p.original.name,
      pill: null,
      pillClass: '',
      purpose: p.original.purpose,
      price: p.original.price,
      priceSub: p.original.priceSub,
      oneTimeUrl: p.original.cart,
      subUrl: p.original.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Original_2025.png',
      recommended: false
    },
    {
      key: 'pro',
      name: p.pro.name,
      pill: 'MOTIVATION',
      pillClass: 'pill--blue',
      purpose: p.pro.purpose,
      price: p.pro.price,
      priceSub: p.pro.priceSub,
      oneTimeUrl: p.pro.cart,
      subUrl: p.pro.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Pro_2025.png',
      recommended: false
    },
    {
      key: 'elite',
      name: p.elite.name,
      pill: 'STRESS RELIEF',
      pillClass: 'pill--gold',
      purpose: p.elite.purpose,
      price: p.elite.price,
      priceSub: p.elite.priceSub,
      oneTimeUrl: p.elite.cart,
      subUrl: p.elite.cart,
      img: 'https://www.brainzyme.com/cdn/shop/files/Packshot_Focus_Single_Pack_Deals_Elite_2025.png',
      recommended: true
    }
  ];

  var isDuration = false;

  function renderCard(prod) {
    var recClass = prod.recommended ? ' shelf-card--recommended' : '';
    var recBadge = prod.recommended ? '<div class="shelf-card-rec-badge">Most relevant for gut-brain stress support</div>' : '';
    var pillHtml = prod.pill ? '<span class="pill ' + prod.pillClass + '">' + prod.pill + '</span>' : '';
    var url = isDuration ? prod.subUrl : prod.oneTimeUrl;
    var price = isDuration ? prod.priceSub : prod.price;
    return '<div class="shelf-card' + recClass + '">' +
      recBadge +
      pillHtml +
      '<img class="shelf-card-img" src="' + prod.img + '" alt="' + prod.name + '" loading="lazy" onerror="this.style.display=\'none\'">' +
      '<h3 class="shelf-card-name">' + prod.name + '</h3>' +
      '<p class="shelf-card-purpose">' + prod.purpose + '</p>' +
      '<div class="shelf-card-price">' + price + '</div>' +
      '<a class="shelf-card-cta" href="' + url + '">Buy Now — ' + price + '</a>' +
      '<a class="shelf-card-sub-cta" href="' + prod.subUrl + '">Subscribe &amp; Save — ' + prod.priceSub + '</a>' +
      '</div>';
  }

  function renderShelf() {
    var el = document.getElementById('shelfGrid');
    if (!el) return;
    el.innerHTML = PRODUCTS.map(renderCard).join('');
  }

  document.addEventListener('DOMContentLoaded', renderShelf);
})();

/* ─────────────────────────────────────────────────────────────────────
   4. PLAN YOUR PATH — Gut-Brain lane (Tab 2 = lifestyle, Tab 3 = formula quiz)
   ───────────────────────────────────────────────────────────────────── */

(function () {
  document.addEventListener('DOMContentLoaded', function () {

    /* Tab switching */
    var tabs = document.querySelectorAll('.planpath-tab');
    var panels = document.querySelectorAll('.planpath-panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) { t.classList.remove('active'); t.setAttribute('aria-selected', 'false'); });
        panels.forEach(function (p) { p.classList.remove('active'); });
        tab.classList.add('active');
        tab.setAttribute('aria-selected', 'true');
        var target = tab.getAttribute('data-tab');
        var panel = document.querySelector('.planpath-panel[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });

    /* Formula quiz */
    var market = 'us';
    var p = BZ.PRODUCTS[market];
    var QUIZ_RESULTS = {
      original: { name: p.original.name, blurb: 'Mild everyday support — L-Theanine + essential nutrients for steady, calm focus. A good starting point for gut-brain nutritional support.', url: '/products/brainzyme-original-milder-formula' },
      pro:      { name: p.pro.name,      blurb: 'Motivation support through the dopamine pathway — L-Tyrosine + B-complex for motivated, clear gut-brain signalling. Targeted at the focus and drive side of the axis.*', url: '/products/brainzyme-professional-stronger-formula' },
      elite:    { name: p.elite.name,    blurb: 'Stress-free focus and positive mood through the GABA pathway — 29 ingredients including L-Theanine, Ashwagandha, and Magnesium. Most complete formula for gut-brain stress support.*', url: '/products/brainzyme-elite-3-in-1-formula' }
    };

    var votes = {};
    document.querySelectorAll('.pp-quiz-options input[type="radio"]').forEach(function (input) {
      input.addEventListener('change', function () {
        votes[input.name] = input.value;
        if (Object.keys(votes).length === 3) {
          var counts = { original: 0, pro: 0, elite: 0 };
          Object.values(votes).forEach(function (v) { if (counts[v] !== undefined) counts[v]++; });
          var winner = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
          var res = QUIZ_RESULTS[winner];
          document.getElementById('ppQuizName').textContent = res.name;
          document.getElementById('ppQuizBlurb').textContent = res.blurb;
          var cta = document.getElementById('ppQuizCta');
          // Prefer the page's own data-url (bz-planpath-tabs-* snippet, elite_url render
          // param) over the baked default - lets a page with an in-page buy form pass a
          // hash anchor while every other page falls back to the PDP (52E-2 2026-08-20).
          var domUrl = null;
          var domDiv = document.querySelector('.pp-quiz-formulas [data-formula="' + winner + '"]');
          if (domDiv && domDiv.dataset && domDiv.dataset.url) domUrl = domDiv.dataset.url;
          cta.href = domUrl || res.url;
          cta.textContent = 'Try it — 365-day returns';
          document.getElementById('ppQuizResult').style.display = 'block';
        }
      });
    });

    var resetBtn = document.getElementById('ppQuizReset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        votes = {};
        document.querySelectorAll('.pp-quiz-options input[type="radio"]').forEach(function (i) { i.checked = false; });
        document.getElementById('ppQuizResult').style.display = 'none';
      });
    }
  });
})();

/* ─────────────────────────────────────────────────────────────────────
   5. PAGE INTERACTIONS (accordion, symptom checker, progress bar, sticky CTA, stat counters)
   ───────────────────────────────────────────────────────────────────── */

/* Accordion toggle — shared pattern */
function toggleAccordion(btn) {
  var isOpen = btn.getAttribute('aria-expanded') === 'true';
  var panel = btn.nextElementSibling;
  var chevron = btn.querySelector('.accordion-chevron');
  if (isOpen) {
    btn.setAttribute('aria-expanded', 'false');
    panel.style.maxHeight = null;
    panel.classList.remove('open');
    if (chevron) chevron.textContent = '+';
  } else {
    btn.setAttribute('aria-expanded', 'true');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    panel.classList.add('open');
    if (chevron) chevron.textContent = '−';
  }
}

/* Symptom checker — Gut-Brain lane messages */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.sign-item.selectable');
    var countEl = document.getElementById('symptomCount');
    var resultEl = document.getElementById('symptomResult');
    var count = 0;

    var MESSAGES = [
      null,
      'One sign — the lifestyle factors section is a great starting point for gut-brain support.',
      'A couple of signs — nutritional support for gut-brain communication is worth considering.*',
      '[N] signs — your gut-brain axis could benefit from a targeted multi-pathway approach. Read on.*',
      '[N] of 6 signs — a combined dopamine + GABA precursor formula like Brainzyme® may be a good fit.*',
      '[N] of 6 signs — this pattern strongly suggests your gut-brain axis would benefit from consistent nutritional support.*',
      '[N] of 6 signs — both FOCUS ELITE™ and FOCUS PRO™ address different sides of this pattern. Read on to find your fit.*'
    ];

    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var checked = item.getAttribute('aria-checked') === 'true';
        if (checked) {
          item.setAttribute('aria-checked', 'false');
          item.classList.remove('selected');
          count--;
        } else {
          item.setAttribute('aria-checked', 'true');
          item.classList.add('selected');
          count++;
        }
        if (countEl) countEl.textContent = count;
        if (resultEl) {
          if (count === 0) {
            resultEl.innerHTML = '';
            resultEl.style.display = 'none';
          } else {
            var msg = MESSAGES[count] || MESSAGES[MESSAGES.length - 1];
            resultEl.innerHTML = msg.replace('[N]', count);
            resultEl.style.display = 'block';
          }
        }
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); item.click(); }
      });
    });
  });
})();

/* Buyer's guide checklist progress dots */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var items = document.querySelectorAll('.guide-checklist li[data-check]');
    var dots = document.querySelectorAll('.check-dot');
    var label = document.getElementById('checkLabel');
    if (!items.length || !dots.length) return;

    var seen = new Set();
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var n = entry.target.getAttribute('data-check');
          seen.add(n);
          dots.forEach(function (d) {
            if (seen.has(d.getAttribute('data-check'))) d.classList.add('active');
          });
          if (label) label.textContent = seen.size + '/6 explored';
        }
      });
    }, { threshold: 0.6 });

    items.forEach(function (item) { obs.observe(item); });
  });
})();

/* Animated stat counters */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var els = document.querySelectorAll('[data-target]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        obs.unobserve(entry.target);
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-target'));
        var isFloat = target % 1 !== 0;
        var suffix = el.innerHTML.replace(/[\d.]/g, '').trim();
        var start = 0;
        var duration = 1200;
        var startTime = null;
        function step(ts) {
          if (!startTime) startTime = ts;
          var progress = Math.min((ts - startTime) / duration, 1);
          var val = isFloat ? (progress * target).toFixed(1) : Math.floor(progress * target);
          el.innerHTML = val + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.3 });
    els.forEach(function (el) { obs.observe(el); });
  });
})();

/* Progress bar + sticky CTA — Gut-Brain lane US */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var bar = document.getElementById('progressBar');
    var lbl = document.getElementById('progressLabel');
    var cta = document.getElementById('stickyCta');
    var ctaText = document.getElementById('stickyCtaText');
    var ctaLink = document.getElementById('stickyCtaLink');

    var MESSAGES = [
      { pct: 0.05, text: 'Gut-brain science, no hype',         label: 'Learn more',              url: 'https://brainzyme-us.myshopify.com/products/gaba-supplements' },
      { pct: 0.20, text: 'The gut-brain axis explained',        label: 'See the science',          url: 'https://brainzyme-us.myshopify.com/products/gaba-supplements' },
      { pct: 0.40, text: '365-day money-back guarantee',        label: 'Try Risk-Free',            url: 'https://brainzyme-us.myshopify.com/cart/48197708710080:1' },
      { pct: 0.60, text: '6,020+ verified reviews',             label: 'Try FOCUS ELITE™',   url: 'https://brainzyme-us.myshopify.com/cart/48197708710080:1' }
    ];

    function onScroll() {
      var scrolled = window.scrollY;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      var pct = total > 0 ? scrolled / total : 0;

      if (bar) bar.style.width = (pct * 100) + '%';
      if (lbl) lbl.textContent = Math.round(pct * 100) + '%';

      if (cta) {
        if (pct > 0.10 && pct < 0.95) {
          cta.classList.add('visible');
        } else {
          cta.classList.remove('visible');
        }
      }

      var active = MESSAGES[0];
      for (var i = 0; i < MESSAGES.length; i++) {
        if (pct >= MESSAGES[i].pct) active = MESSAGES[i];
      }
      if (ctaText) ctaText.textContent = active.text;
      if (ctaLink) {
        ctaLink.textContent = active.label;
        ctaLink.href = active.url;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

/* Proof strip + star row — shared component initialiser */
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var market = 'us';
    var mkt = BZ.MARKETS && BZ.MARKETS[market];

    /* Star row */
    document.querySelectorAll('[data-component="starRow"]').forEach(function (el) {
      if (!mkt) return;
      el.innerHTML = '<div class="star-row"><span class="stars">★★★★★</span><span class="rating">' + mkt.reviewStats.rating + '/5 from ' + mkt.reviewStats.count + ' ' + mkt.reviewStats.source + '</span></div>';
    });

    /* Proof strip */
    document.querySelectorAll('[data-component="proofStrip"]').forEach(function (el) {
      if (!mkt || !mkt.proofStrip) return;
      el.innerHTML = '<div class="proof-strip">' + mkt.proofStrip.map(function (s) { return '<span class="proof-item">' + s + '</span>'; }).join('') + '</div>';
    });
  });
})();
